(function () {
  if (window.__dtc3MediaTextBannerLoaded) return;
  window.__dtc3MediaTextBannerLoaded = true;

  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function typeText(element) {
    if (element.dataset.dtc3TypewriterInitialized === 'true') return;

    const output = element.querySelector('[data-dtc3-typewriter-output]');
    const text = element.dataset.dtc3TypewriterText || '';
    const speed = Number.parseInt(element.dataset.dtc3TypewriterSpeed || '45', 10);
    if (!output || !text) return;

    element.dataset.dtc3TypewriterInitialized = 'true';

    if (reducedMotionQuery.matches) {
      output.textContent = text;
      return;
    }

    output.textContent = '';
    element.classList.add('is-typing');

    let index = 0;
    const writeNext = () => {
      index += 1;
      output.textContent = text.slice(0, index);

      if (index < text.length) {
        window.setTimeout(writeNext, speed);
      } else {
        element.classList.remove('is-typing');
        element.classList.add('is-typed');
      }
    };

    window.setTimeout(writeNext, 180);
  }

  function initTypewriters(scope) {
    const elements = scope.querySelectorAll('[data-dtc3-typewriter]');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(typeText);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          typeText(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    elements.forEach((element) => observer.observe(element));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTypewriters(document));
  } else {
    initTypewriters(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTypewriters(event.target);
  });
})();
